import React, { useState, useEffect, useRef } from "react";



import GlorySlider from "./GlorySlider";
// import "./portfolio.css";
import { useNavigate, Link, useParams } from "react-router-dom";
import TestimonialSlider from "./TestimonialSlider";
import db from "./Firebase";
import axios from "axios";
import Geocode from "react-geocode";
// import { firebase, auth } from './FirebaseLogin';
import Swal from 'sweetalert2'
import TopLink from "./toplink";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import Footer from "./Footer";
import ReactStars from "react-rating-stars-component";
import { firebase, auth } from './FirebaseLogin';
import Select from 'react-select';
import { collection, query, where, getDocs } from "firebase/firestore";
import { Form, Button } from "react-bootstrap";



function NewPortfolio() {
    let params = useParams();
    const [selectedOption, setSelectedOption] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [certificateCount, setCertificateCount] = useState(0);
    const [personalData, setPersonalData] = useState({});
    const [personalService, setPersonalService] = useState({});
    const [colorData, setColorData] = useState({});
    const [color, setcolor] = useState("white")
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [edata, setEdata] = useState([]);
    const [rating, setRating] = useState(0);
    const [ind, setInd] = useState(null);
    const initialFormStateFeedback = { email: '', password: '', created_date: new Date() }
    const [submit, setSubmit] = useState(initialFormStateFeedback);
    const initialFormStateEnquiry = { name: '', phone_no: '', message: '', service: '', username: '', created_date: new Date() }
    const [submitEnquiry, setSubmitEnquiry] = useState(initialFormStateEnquiry);
    const [serviceName, setServiceName] = useState('');
    const [serviceCategory, setServiceCategory] = useState('');
    const [amount, setAmount] = useState('');

    const [isVerified, setIsVerified] = useState(false);
    const [verifiedPhoneNo, setVerifiedPhoneNo] = useState("");
    const [verifiedName, setVerifiedName] = useState("");

    const galleryRef = useRef(null);
    const [usernames, setUsernames] = useState([]);


    useEffect(() => {
        navigate('/error');
        // if (id) {
        //     window.location.href = `https://youvati.com/${id}`;
        // }
    }, []);

    useEffect(() => {
        const verified = localStorage.getItem("isVerified");
        const verifiedPhoneNo = localStorage.getItem("verifiedPhoneNo");
        const name = localStorage.getItem("verifiedName");
        // setIsVerified(verified)
        // setVerifiedPhoneNo(localStorage.getItem("isVerified"));

        if (verified) {
            setIsVerified(true)
            setVerifiedPhoneNo(verifiedPhoneNo)
            setVerifiedName(name)
            // alert("verified")
            // alert(verifiedPhoneNo)
        } else {
            setIsVerified(false)
            setVerifiedPhoneNo(verifiedPhoneNo)
            setVerifiedName(name)
            // alert("false")
        }
    }, []);

    // localStorage.setItem("email", submit.email);



    const initialFormStateAppointment = { start_date_time: '', charges: '', description: '', address: '', willing_to_travel: '', name: '', parlour: '', payment_method: '', payment_mode: '', phone: '', service_name: '', service_category: '', status: '', time: '', uid: '', username: '', date: new Date() }
    const [submitAppointment, setSubmitAppointment] = useState(initialFormStateAppointment);


    const [mynumber, setnumber] = useState("");
    const [otp, setotp] = useState('');
    const [name, setName] = useState('');
    const [service_name, setService_name] = useState('');
    const [service_category, setService_category] = useState('');
    const [show, setshow] = useState(false);
    const [finalShow, setFinalShow] = useState(false);
    const [final, setfinal] = useState('');
    const [showNum, setshowNum] = useState(true);
    const [showOtpBox, setshowOtpBox] = useState(false);
    const [showMessage, setshowMessage] = useState(false);
    const [showEnquiry, setShowEnquiry] = useState(false);
    const [showAp, setShowAp] = useState(false);



    const [sendEnq, setSendEnq] = useState(false);
    const [viewContactLogin, setViewContactLogin] = useState(false);
    const [viewContactNumber, setViewContactNumber] = useState(false);
    const [viewVerifyOtp, setViewVerifyOtp] = useState(false);
    const [viewVerifyOtpSendMessage, setViewVerifyOtpSendMessage] = useState(false);
    const [viewOtpPhone, setViewOtpPhone] = useState(false);

    const [showButtonEnquiry, setShowButtonEnquiry] = useState(true);
    const [showButtonContact, setShowButtonContact] = useState(true);

    const [enquirySubmitted, setEnquirySubmitted] = useState(false);
    const [showContactSubmitted, setShowContactSubmitted] = useState(false);


    const [viewOtpValue, setViewOtpValue] = useState("");

    const ratingExample = {
        size: 25,
        value: rating,
        edit: false,
        isHalf: true
    };

    const [topping, setTopping] = useState("no")

    const onOptionChange = e => {
        setTopping(e.target.value)
        console.log(topping)
    }

    const currentDateE = new Date().toISOString().split('T')[0];



    const handleChangeAp = (e) => {
        const { id, value, type, checked } = e.target;

        if (type === "radio") {
            // Handle radio input
            setSubmitAppointment({
                ...submitAppointment,
                [id]: value === true, // Convert the string value to a boolean
            });
        } else {
            setSubmitAppointment({
                ...submitAppointment,
                [id]: value, // Handle other input types
            });
        }

        // Get the current date and time
        // const currentDate = new Date().toISOString().slice(0, 16); // Format: "YYYY-MM-DDTHH:MM"

        // if (id === "start_date_time") {
        //     if (e.target.value < currentDate) {
        //         alert
        //     } else {

        //     }
        // } else {
        //     alert("not date")
        // }

        // Check if the selected date/time is in the past

    }


    const scrollGallery = (direction) => {
        const slider = galleryRef.current;
        const scrollAmount = 300;

        if (!slider) return;

        if (direction === "left") {
            slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else {
            slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };


    useEffect(() => {
        const fetchDataAndStoreUsernames = async () => {
            try {
                const snapshot = await firebase.firestore().collection("website_portfolio_listing").get();

                // Array to store usernames
                const usernamesArray = [];

                // Iterate through the documents in the collection
                snapshot.forEach((doc) => {
                    const username = doc.data().username;
                    usernamesArray.push(username);
                });

                // Set the state with the array of usernames
                setUsernames(usernamesArray);
                console.log(usernamesArray)
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Call the function to fetch data and store usernames
        fetchDataAndStoreUsernames();
    }, []);




    const appointmentStatus = (name, cat, amt) => {
        setShowEnquiry(false);
        setShowAp(true);
        setServiceName(name)
        setServiceCategory(cat)
        setAmount(amt)
        openModalShow();
        // alert(name);
    }

    const handleSubmitAp = (e) => {
        console.log(serviceCategory)
        console.log(serviceName)
        console.log(amount)
        e.preventDefault();
        console.log(submitAppointment)
        console.log(topping)
        console.log(amount)
        const startDateTime = new Date(submitAppointment.start_date_time); // Convert to JavaScript Date object

        const formattedTime = moment(startDateTime).format("h:mm A");
        // console.log(formattedTime);
        // // Convert the string to a JavaScript Date object
        // const bookedDate = new Date(submitAppointment.start_date_time);

        // // Create a Firestore Timestamp from the JavaScript Date object
        // const firestoreTimestamp = firebase.firestore.Timestamp.fromDate(bookedDate);
        // console.log(firestoreTimestamp)

        // ------------------------------------------------------------------------

        if (submitAppointment.phone.length === 10) {
            db.collection("appointments_data").add({
                'booked_date': new Date(submitAppointment.start_date_time),
                'charges': parseInt(amount),
                'description': '',
                'name': submitAppointment.name,
                'parlour': personalData.business_name,
                'payment_method': '',
                'payment_mode': '',
                'phone': submitAppointment.phone,
                'service_name': serviceCategory,
                'service_category': serviceName,
                'status': '0',
                'time': formattedTime,
                'type': 'Website',
                'uid': '',
                'username': params.id,
                'date': new Date(),
                'address': topping === "no" ? personalData.business_name : submitAppointment.address,
                'willing_to_travel': topping,
                'updated_date': new Date(),
                'rescheduled': "no",
            }).then(() => {
                console.log('Submitted Successfully');
                sendWhatsappBooking(submitAppointment.phone, submitAppointment.name, personalData.business_name)
                sendWhatsappBookingRequestToParlour(submitAppointment.phone, submitAppointment.name, personalData.business_name)
                db.collection("app_notification").add({ 'message': `You got one new appointment request from ${submitAppointment.name}`, 'link': "AppointmentList", 'status': "0", "uid": personalData.uid, 'created_date': new Date() }).then(() => {
                    console.log("user added");
                })
                setShowEnquiry(false);
                const Toast = Swal.mixin({
                    toast: true,
                    background: 'white',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                });

                Toast.fire({
                    icon: 'success',
                    title: 'Appointment Requested Successfully'
                });

                setshow(true);
                closeModel();
                setSubmitAppointment({ start_date_time: '', charges: '', description: '', name: '', parlour: '', payment_method: '', payment_mode: '', phone: '', service_name: '', service_category: '', status: '', time: '', uid: '', username: '', date: new Date() });
            });
        } else {
            alert("Phone no should not be less or more than 10 digit")
        }


    };


    const handleChangeE = (e) => {
        const { id, value } = e.target
        setSubmitEnquiry({ ...submitEnquiry, [id]: value })
    }

    const enquiryStatus = (name) => {
        setShowAp(false);
        setShowEnquiry(true);
        setServiceName(name)
        openModalShow();
        setSubmitEnquiry({ name: '', phone_no: '', message: `Hey ${personalData.first_name},\nStumbled upon your details on the Youvati website – your profile looks great! 😄 I'm interested in learning more about your services. Could you provide me with more information?\n\nThanks,`, service: '', username: '', created_date: new Date() })
        // alert(name);
    }

    const notifyApp = (msg) => {
        // Call the user's CollectionReference to add a new user
        db.collection("app_notification").add({ 'message': msg, 'link': "Enquiries", 'status': "0", "uid": personalData.uid, 'created_date': new Date() }).then(() => {
            console.log("user added");
        })
    }




    const handleSubmitE = (e, msg) => {
        e.preventDefault()
        console.log(submitEnquiry);
        db.collection("enquiry").add({
            'name': submitEnquiry.name,
            'phone_no': submitEnquiry.phone_no,
            'message': submitEnquiry.message,
            'service': serviceName,
            'username': params.id,
            'status': '0',
            'created_date': new Date(),
        }).then(() => {
            sendWhatsappEnquiry(submitEnquiry.phone_no, submitEnquiry.name, personalData.business_name)
            sendWhatsappEnquiryToParlour(submitEnquiry.phone_no, submitEnquiry.name, personalData.business_name)
            db.collection("customer_data").add({ 'name': submitEnquiry.name, 'email': '', 'phone_no': submitEnquiry.phone_no, 'type': "enquiry", 'additional': params.id, 'created_date': new Date(), }).then(() => {
                console.log("data added");
            });
            notifyApp(msg = submitEnquiry.message);
            console.log('Submitted Successfully');
            setShowEnquiry(false);
            const Toast = Swal.mixin({
                toast: true,
                background: 'white',
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'success',
                title: 'Submitted Successfully'
            })
            setshow(true)
            closeModel();
            // navigate(`/${submit.username}`);
            setSubmitEnquiry({ name: '', phone_no: '', message: '', service: '', username: '', created_date: new Date() })
        })
    }



    const handleChangeOTP = (e) => {
        const { id, value } = e.target
        setViewOtpValue(e.target.value)
        console.log(e.target.value);
    }

    const [submitSendEnquiry, setSubmitSendEnquiry] = useState({
        full_name: '',
        phone_no: '',
        email: '',
        function_date: '',
        message: '',
        notifyOnWhatsApp: false,
    });

    const handleSubmitSendEnquiry = (e) => {
        console.log("calling enquiry")
        e.preventDefault();
        // Handle form submission logic here
        console.log(submitSendEnquiry);
        setViewOtpPhone(submitSendEnquiry.phone_no);


        if (submitSendEnquiry.phone_no.length === 10) {
            // alert(`+91${submitSendEnquiry.phone_no}`)
            setShowButtonEnquiry(false)
            let verify = new firebase.auth.RecaptchaVerifier('recaptcha-container');
            auth.signInWithPhoneNumber(`+91${submitSendEnquiry.phone_no}`, verify).then((result) => {
                setViewVerifyOtp(false)
                setSendEnq(false)
                setViewContactLogin(false)
                setViewContactNumber(false)
                setViewVerifyOtpSendMessage(true)
                setViewOtpValue("")
                setfinal(result);
                // alert("code sent")
                setshow(true);
                const Toast = Swal.mixin({
                    toast: true,
                    background: 'white',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Code Sent....'
                })
            })
                .catch((err) => {
                    alert(err);
                    console.log(err);
                    // window.location.reload()
                });

        } else {
            setShowButtonEnquiry(true)
            alert("please enter 10 digit valid phone number.")
        }

    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSubmitSendEnquiry((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleInputChangeViewContact = (e) => {
        const { name, value, type, checked } = e.target;
        setSubmitViewContact((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };


    const [submitViewContact, setSubmitViewContact] = useState({
        full_name: '',
        phone_no: '',
        notifyOnWhatsApp: false,
    });

    const handleSubmitViewContact = (e) => {
        e.preventDefault();
        setViewOtpValue("")
        // Handle form submission logic here
        // console.log(submitViewContact);
        setViewOtpPhone(submitViewContact.phone_no);
        // alert(submitViewContact.phone_no)


        console.log(submitViewContact.phone_no.length)
        if (submitViewContact.phone_no.length === 10) {
            setShowButtonContact(false)

            let verify = new firebase.auth.RecaptchaVerifier('recaptcha-container');
            auth.signInWithPhoneNumber(`+91${submitViewContact.phone_no}`, verify).then((result) => {
                setViewVerifyOtp(true);
                setSendEnq(false)
                setViewContactLogin(false)
                setViewContactNumber(false)
                setViewVerifyOtpSendMessage(false)
                setViewOtpValue("")

                setfinal(result);
                // alert("code sent")
                // setshow(true);
                const Toast = Swal.mixin({
                    toast: true,
                    background: 'white',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Code Sent....'
                })
            })
                .catch((err) => {
                    alert(err);
                    window.location.reload()
                });


        } else {
            alert("please enter 10 digit valid phone number.")
        }

        // if (submitViewContact.phone_no.length == 10) {
        //     alert("please enter 10 digit valid phone number.");
        // } else {
        //     let verify = new firebase.auth.RecaptchaVerifier('recaptcha-container');
        //     auth.signInWithPhoneNumber(`+91${submitViewContact.phone_no}`, verify).then((result) => {
        //         setfinal(result);
        //         alert("code sent");
        //         // setshow(true);
        //         // setFinalShow(true);
        //         // setshowNum(false);
        //         // setshowOtpBox(true);
        //         setViewVerifyOtp(true)
        //         setSendEnq(false)
        //         setViewContactLogin(false)
        //         setViewContactNumber(false)
        //         setViewVerifyOtpSendMessage(false)
        //         // db.collection("customer_data").add({ 'name': name, 'email': '', 'phone_no': mynumber, 'type': "book_now", 'additiona': params.id, 'created_date': new Date(), }).then(() => {
        //         //     console.log("data added");
        //         // });
        //     })
        //         .catch((err) => {
        //             alert(err);
        //             window.location.reload()
        //         });
        // }

        // db.collection("website_bridal_enquiry").add({
        //     'full_name': submitSendEnquiry.full_name,
        //     'phone_no': submitSendEnquiry.phone_no,
        //     'email': submitSendEnquiry.email,
        //     'function_date': submitSendEnquiry.function_date,
        //     'message': submitSendEnquiry.message,
        //     'notifyOnWhatsApp': submitSendEnquiry.notifyOnWhatsApp,
        //     'username': params.id,
        //     'status': '0',
        //     'created_date': new Date(),
        // }).then(() => {
        //     const Toast = Swal.mixin({
        //         toast: true,
        //         background: 'white',
        //         position: 'top-end',
        //         showConfirmButton: false,
        //         timer: 3000,
        //         timerProgressBar: true,
        //         didOpen: (toast) => {
        //             toast.addEventListener('mouseenter', Swal.stopTimer)
        //             toast.addEventListener('mouseleave', Swal.resumeTimer)
        //         }
        //     })

        //     Toast.fire({
        //         icon: 'success',
        //         title: 'Submitted Successfully'
        //     })
        // })
    };

    const leftPartStyle = {
        flex: 1,
        border: "none",
        boxSizing: "border-box",
        backgroundColor: "#7d6853",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    };

    const rightPartStyle = {
        flex: 1,
        border: "none",
        boxSizing: "border-box",
        backgroundColor: "#7d6853",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    };

    const editPhone = () => {
        setSendEnq(true)
        setShowButtonEnquiry(true)
        setViewVerifyOtp(false)
        setViewContactLogin(false)
        setViewContactNumber(false)
        setViewVerifyOtpSendMessage(false)
        setEnquirySubmitted(false)
        setShowContactSubmitted(false)
    }


    const editPhoneContact = () => {
        setShowButtonEnquiry(true)
        setShowButtonContact(true)
        setSendEnq(false)
        setViewVerifyOtp(false)
        setViewContactLogin(true)
        setViewContactNumber(false)
        setViewVerifyOtpSendMessage(false)
        setEnquirySubmitted(false)
        setShowContactSubmitted(false)
    }

    const sendEnquiryButton = () => {
        if (isVerified) {
            setSubmitSendEnquiry({
                full_name: verifiedName,
                phone_no: verifiedPhoneNo,
                email: '',
                function_date: '',
                message: '',
                notifyOnWhatsApp: false,
            })
        }
        if (sendEnq) {
            setSendEnq(true)
            setShowButtonEnquiry(true)
            setViewVerifyOtp(false)
            setViewContactLogin(false)
            setViewContactNumber(false)
            setViewVerifyOtpSendMessage(false)
            setEnquirySubmitted(false)
            setShowContactSubmitted(false)
        } else {
            setSendEnq(true)
            setShowButtonEnquiry(true)
            setViewVerifyOtp(false)
            setViewContactLogin(false)
            setViewContactNumber(false)
            setViewVerifyOtpSendMessage(false)
            setEnquirySubmitted(false)
            setShowContactSubmitted(false)
        }
    }

    const viewContactLoginButton = () => {
        if (viewContactLogin) {
            setSendEnq(false)
            setShowButtonContact(true)
            setViewVerifyOtp(false)
            setViewContactLogin(true)
            setViewContactNumber(false)
            setViewVerifyOtpSendMessage(false)
            setEnquirySubmitted(false)
            setShowContactSubmitted(false)
        } else {
            setSendEnq(false)
            setViewVerifyOtp(false)
            setViewContactLogin(true)
            setShowButtonContact(true)
            setViewContactNumber(false)
            setViewVerifyOtpSendMessage(false)
            setEnquirySubmitted(false)
            setShowContactSubmitted(false)
        }
    }





    const signin = (num) => {

        if (num.length < 10) {
            alert("please enter 10 digit valid phone number.");
        } else {
            let verify = new firebase.auth.RecaptchaVerifier('recaptcha-container');
            auth.signInWithPhoneNumber(`+91${mynumber}`, verify).then((result) => {
                setfinal(result);
                alert("code sent");
                setshow(true);
                setFinalShow(true);
                setshowNum(false);
                setshowOtpBox(true);
                db.collection("customer_data").add({ 'name': name, 'email': '', 'phone_no': mynumber, 'type': "book_now", 'additiona': params.id, 'created_date': new Date(), }).then(() => {
                    console.log("data added");
                });
            })
                .catch((err) => {
                    alert(err);
                    window.location.reload()
                });
        }
    }


    const forVerifiedSendMessage = () => {
        setViewContactNumber(true)
        db.collection("contact_request").add({
            'full_name': verifiedName,
            'phone_no': verifiedPhoneNo,
            'notifyOnWhatsApp': true,
            'username': params.id,
            'status': '0',
            'created_date': new Date(),
        }).then(() => {
            const Toast = Swal.mixin({
                toast: true,
                background: 'white',
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'success',
                title: 'Requested Successfully'
            })
        })
    }

    // Validate OTP
    const ValidateOtpEnquiry = (code) => {

        if (code === null || final === null)
            return;
        final.confirm(code).then((result) => {
            localStorage.setItem("isVerified", true);
            localStorage.setItem("verifiedPhoneNo", submitSendEnquiry.phone_no);
            localStorage.setItem("verifiedName", submitSendEnquiry.full_name);
            setEnquirySubmitted(true)
            setSendEnq(false)
            setViewVerifyOtp(false)
            setViewContactLogin(false)
            setShowButtonContact(false)
            setViewContactNumber(false)
            setViewVerifyOtpSendMessage(false)
            setShowContactSubmitted(false)

            db.collection("website_bridal_enquiry").add({
                'full_name': submitSendEnquiry.full_name,
                'phone_no': submitSendEnquiry.phone_no,
                'email': submitSendEnquiry.email,
                'function_date': submitSendEnquiry.function_date,
                'message': submitSendEnquiry.message,
                'notifyOnWhatsApp': submitSendEnquiry.notifyOnWhatsApp,
                'username': params.id,
                'status': '0',
                'created_date': new Date(),
            }).then(() => {
                const Toast = Swal.mixin({
                    toast: true,
                    background: 'white',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Submitted Successfully'
                })
            })

            // alert("OTP validation Successful");
            // db.collection("service_enquiry").add({
            //     'name': name,
            //     'phone': mynumber,
            //     'created_date': new Date(),
            // }).then(() => {
            //     console.log('Requested successfull');
            //     const Toast = Swal.mixin({
            //         toast: true,
            //         background: '#69aba6',
            //         position: 'top-end',
            //         showConfirmButton: false,
            //         timer: 3000,
            //         timerProgressBar: true,
            //         didOpen: (toast) => {
            //             toast.addEventListener('mouseenter', Swal.stopTimer)
            //             toast.addEventListener('mouseleave', Swal.resumeTimer)
            //         }
            //     })

            //     Toast.fire({
            //         icon: 'success',
            //         title: 'Thank you for your interest ! We will get in touch with you'
            //     })
            // });
            // console.log(mynumber)
            // setFinalShow(true);
            // setshowOtpBox(false);
            // setshowMessage(true);

            // success
        }).catch((err) => {
            alert("Wrong code");
        })
    }

    const forVerifiedViewContact = () => {
        setViewContactNumber(true)
        setEnquirySubmitted(false)
        setShowContactSubmitted(false)
        setSendEnq(false)
        setViewVerifyOtp(false)
        setViewContactLogin(false)
        setShowButtonContact(false)
        setViewVerifyOtpSendMessage(false)
        db.collection("contact_request").add({
            'full_name': verifiedName,
            'phone_no': verifiedPhoneNo,
            'notifyOnWhatsApp': true,
            'username': params.id,
            'status': '0',
            'created_date': new Date(),
        }).then(() => {
            // const Toast = Swal.mixin({
            //     toast: true,
            //     background: 'white',
            //     position: 'top-end',
            //     showConfirmButton: false,
            //     timer: 3000,
            //     timerProgressBar: true,
            //     didOpen: (toast) => {
            //         toast.addEventListener('mouseenter', Swal.stopTimer)
            //         toast.addEventListener('mouseleave', Swal.resumeTimer)
            //     }
            // })

            // Toast.fire({
            //     icon: 'success',
            //     title: 'Requested Successfully'
            // })
        })
    }

    const ValidateOtpViewContact = (code) => {
        // alert("yee")
        if (code === null || final === null)
            return;
        final.confirm(code).then((result) => {
            localStorage.setItem("isVerified", true);
            localStorage.setItem("verifiedPhoneNo", submitViewContact.phone_no);
            localStorage.setItem("verifiedName", submitViewContact.full_name);
            setViewContactNumber(true)
            setEnquirySubmitted(false)
            setShowContactSubmitted(false)
            setSendEnq(false)
            setViewVerifyOtp(false)
            setViewContactLogin(false)
            setShowButtonContact(false)
            setViewVerifyOtpSendMessage(false)

            db.collection("contact_request").add({
                'full_name': submitViewContact.full_name,
                'phone_no': submitViewContact.phone_no,
                'notifyOnWhatsApp': submitViewContact.notifyOnWhatsApp,
                'username': params.id,
                'status': '0',
                'created_date': new Date(),
            }).then(() => {
                const Toast = Swal.mixin({
                    toast: true,
                    background: 'white',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Requested Successfully'
                })
            })
        }).catch((err) => {
            alert("Wrong code");
        })
    }

    const openModalShow = () => {
        // alert("ooo")
        window.openModelshow();
    }

    const closeModel = () => {
        window.openModelNew();
    }

    const handleChange = (e) => {
        setnumber(e.target.value);
    }
    const testi = () => {
        // window.websiteView();
        window.testimonial(edata);
        // alert(JSON.stringify(edata));
        // alert("2")
    }
    const [currentDate, setCurrentDate] = useState('');
    useEffect(() => {
        const fetchPortfolioAndCertificates = async () => {
            try {
                // Step 1: Fetch Portfolio Data
                const q = query(
                    collection(db, "nv_portfolio_details"),
                    where("username", "==", params.id.toLowerCase())
                );

                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const portfolioData = querySnapshot.docs[0].data();
                    setPersonalData(portfolioData);

                    // Step 2: Fetch Certificate Count using phone_no
                    if (portfolioData.phone_no) {
                        const certQuery = query(
                            collection(db, "nv_certificates"),
                            where("phone_no", "==", portfolioData.phone_no)
                        );

                        const certSnapshot = await getDocs(certQuery);
                        setCertificateCount(certSnapshot.size); // Number of documents found
                    }
                } else {
                    console.error("No portfolio found!");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPortfolioAndCertificates();

        const formattedDate = moment().format('YYYY-MM-DD[T]HH:mm');
        setCurrentDate(formattedDate);
        db.collection("portfolio_details").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
            // alert("personal_details calling")
            // setCustomersData(
            //     snapshot.docs.map((doc) => ({
            //         id: doc.id,
            //         data: doc.data(),
            //     }))
            // );
            snapshot.docs.map(e => setPersonalService(e.data()))
            if (snapshot.docs.length == 0) {
                navigate('/error');
            } else {
                // alert("exists")
                setIsLoading(false);
            }
        });

        db.collection("website_color_code").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
            snapshot.docs.map(e => setColorData(e.data()))
            if (snapshot.docs.length == 0) {
                // navigate('/error');
            } else {
                // alert("exists")
                // setIsLoading(false);
                // alert(colorData.color_code)
                if (colorData.color_code === "white") {
                    setcolor("white")
                } else if (colorData.color_code === "black") {
                    setcolor("black")
                }
                else if (colorData.color_code === "perl") {
                    setcolor("#fefbe9")
                }
                else if (colorData.color_code === "blossom") {
                    setcolor("#ffb7c5")
                }
                else if (colorData.color_code === "lime") {
                    setcolor("#c3fd38")
                }
                else if (colorData.color_code === "lavender") {
                    setcolor("#e6e6fa")
                }
                else if (colorData.color_code === "sunbeam") {
                    setcolor("#ffefd5")
                }
                else if (colorData.color_code === "fresh") {
                    setcolor("#bdfcc9")
                }
                else if (colorData.color_code === "glow") {
                    setcolor("#f0e6f0")
                }
                else if (colorData.color_code === "quartz") {
                    setcolor("#f7cac9")
                }
                else if (colorData.color_code === "violet") {
                    setcolor("#b673b0")
                } else {
                    setcolor("white")
                }
            }
        });

        db.collection("parlour_feedback").where('username', '==', params.id.toLowerCase()).orderBy("created_date", "desc").onSnapshot((snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });



        // var yourRatingData = [];
        db.collection("parlour_feedback").where('username', '==', params.id.toLowerCase()).orderBy("created_date", "desc").onSnapshot((snapshot) => {
            let _5star = snapshot.docs.filter(r => r.data().rating == 5).length;
            let _4star = snapshot.docs.filter(r => r.data().rating == 4).length;
            let _3star = snapshot.docs.filter(r => r.data().rating == 3).length;
            let _2star = snapshot.docs.filter(r => r.data().rating == 2).length;
            let _1star = snapshot.docs.filter(r => r.data().rating == 1).length;

            let sumOfRating = parseInt(_5star + _4star + _3star + _2star + _1star);
            let overallRating = parseInt(5 * _5star + 4 * _4star + 3 * _3star + 2 * _2star + 1 * _1star);
            let averageRating = parseFloat(overallRating / sumOfRating);
            // console.log(averageRating.toFixed(1));
            setRating(averageRating.toFixed(1))
            snapshot.docs.map((e) => {
                // console.log(e.data())

                var data1 = {
                    "name": e.data().full_name,
                    "position": "",
                    "photo": e.data().image,
                    "text": e.data().review,

                };

                edata.push(data1);
                // alert("1")
                testi();
                // alert(data)
            })
        });


        // const slides = document.querySelector('.slides');
        // const dot = document.querySelector('.dot');
        // // have access to it
    }, []);

    // function maskPhoneNumber(phoneNumber) {
    //     // Check if the phoneNumber is valid and contains more than 5 digits
    //     if (!phoneNumber || phoneNumber.length <= 5) {
    //         return phoneNumber; // Return as is if invalid or less than 5 digits
    //     }

    //     const maskedPart = phoneNumber.slice(0, -5).replace(/./g, '*');
    //     const lastFiveDigits = phoneNumber.slice(-5);
    //     return lastFiveDigits + maskedPart;
    // }
    function maskPhoneNumber(phoneNumber) {
        // Check if the phoneNumber is valid and contains more than 5 digits
        if (!phoneNumber || phoneNumber.length <= 5) {
            return phoneNumber; // Return as is if invalid or less than 5 digits
        }

        const firstFiveDigits = phoneNumber.slice(0, 5);
        const maskedPart = phoneNumber.slice(5).replace(/./g, '*');
        return firstFiveDigits + maskedPart;
    }

    const changeStatus = () => {
        openModalShow();
    }

    const sendWhatsappBooking = (phone, name, parlour) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "booking_recived",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            },
                            {
                                "type": "text",
                                "text": parlour
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const sendWhatsappEnquiry = (phone, name, parlour) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "enquiry_recived",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            },
                            {
                                "type": "text",
                                "text": parlour
                            },
                            {
                                "type": "text",
                                "text": personalData.phone_no
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }

    const sendWhatsappEnquiryToParlour = (phone, name, parlour) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "enquiry_to_beautician",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": personalData.business_name
                            },
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }

    const sendWhatsappBookingRequestToParlour = (phone, name, parlour) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "enquiry_to_beautician",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": personalData.business_name
                            },
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    // Helpers (put above return)
    const isVideoUrl = (url = "") => /\.(mp4|webm|ogg)(\?|#|$)/i.test(url);
    const isImageUrl = (url = "") => /\.(jpe?g|png|gif|webp|svg)(\?|#|$)/i.test(url);

    const pickMedia = (item = {}) => {
        const img =
            item?.image_url || item?.image || item?.img || item?.url || "";
        const vid =
            item?.video_url || item?.video || "";

        // 1) Prefer explicit image if present
        if (img) return { type: "image", src: img };

        // 2) If no image but video present AND looks like video
        if (vid && isVideoUrl(vid)) return { type: "video", src: vid };

        // 3) If only one URL present but unknown extension, try image first
        if (vid && !isVideoUrl(vid)) return { type: "image", src: vid };

        return { type: "none", src: "" };
    };

    const MediaThumb = ({ item, boxStyle }) => {
        const { type, src } = pickMedia(item);
        if (type === "video")
            return <video src={src} controls style={boxStyle} />;
        if (type === "image")
            return <img src={src} alt="Gallery" style={boxStyle} onError={(e) => { e.currentTarget.style.display = 'none'; }} />;
        return null;
    };


    return (
        <>

            {isLoading ? <div>
                <img src="images/loader.gif" alt="Youvati loader" class="center" style={{
                    display: "block",
                    marginRight: "auto",
                    position: "absolute",
                    height: "200px",
                    width: "200px",
                    top: "40%",
                    left: "50%",
                    marginLeft: "-96px",
                    marginTop: "-50px"
                }} />
            </div> :
                <div>
                    <section>
                        <div className="navi">
                            <input type="checkbox" id="nav-check" />
                            <div className="nav-header">
                                <div className="nav-title">
                                    <Link to="/">
                                        <img
                                            src="/images/youvati_logo.webp"
                                            alt="Logo"
                                            style={{ height: "27px", marginLeft: "2rem" }}
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div className="nav-links bb" style={{ textAlign: "start" }}>
                                <a href="#portfolio" className="linkcolor">
                                    Portfolio
                                </a>
                                <span className="line">|</span>
                                <a href="#services" className="linkcolor">
                                    Services
                                </a>
                                <span className="line">|</span>
                                {certificateCount > 0 && (
                                    <>
                                        <Link
                                            to={`/${params.id.toLowerCase()}/certificates`}
                                            className="linkcolor"
                                        >
                                            Certification
                                        </Link>
                                        <span className="line">|</span>
                                    </>
                                )}
                                <a href="#reviews" className="linkcolor">
                                    Reviews
                                </a>
                            </div>
                        </div>
                    </section>


                    <section className="" style={{ padding: "22px", backgroundColor: "white" }}>
                        <div className="container">
                            <div className="row row-50 align-items-lg-center justify-content-xl-between" style={{ paddingTop: "2rem", paddingBottom: "3rem" }}>

                                {/* Profile Image Section */}
                                <div className="col-lg-6 text-center">
                                    <div className="block-parallax-element">
                                        <span className="prev-element" data-parallax-scroll='{"y": -30, "x": 0,  "smoothness": 50 }'></span>
                                        <img
                                            src={personalData?.profile_image || "/images/default-profile.png"}
                                            alt={personalData?.name || "Profile Image"}
                                            className="img-fluid"
                                            style={{
                                                borderStyle: "solid",
                                                borderWidth: "3px",
                                                maxWidth: "17rem",
                                                borderImage: "linear-gradient(45deg, rgb(252,79,135), rgb(255,242,86)) 1"
                                            }}
                                        />
                                        <span className="next-element" data-parallax-scroll='{"y": 30, "x": 0,  "smoothness": 50 }'></span>
                                    </div>
                                </div>

                                {/* Business Information Section */}
                                <div className="col-lg-6 col-xl-5">
                                    <h2 className="heading-decorate" style={{ textTransform: "capitalize", fontFamily: "Roboto, sans-serif", color: "black" }}>
                                        {personalData?.business_name || personalData?.name}
                                    </h2>
                                    <p className="midium text-gray-800" style={{ fontFamily: "Roboto, sans-serif", fontSize: "16px", color: "black" }}>
                                        <i>{personalData?.profession || "Profession Not Available"}</i>
                                    </p>
                                    <p className="text-spacing-60" style={{ fontFamily: "Roboto, sans-serif", textAlign: "justify", textJustify: "inter-word", color: "black" }}>
                                        {personalData?.bio || "No biography available."}
                                    </p>

                                    {/* Social Media Links */}
                                    {personalData?.phone_no && (
                                        <a href={`https://api.whatsapp.com/send?phone=${personalData.phone_no}`} target="_blank">
                                            <img src="/images/whatsappp.png" style={{ height: "30px", paddingRight: "10px" }} alt="WhatsApp" />
                                        </a>
                                    )}


                                    {personalData?.instagram_username && (
                                        <a href={personalData.instagram_username.startsWith("http") ? personalData.instagram_username : `https://www.instagram.com/${personalData.instagram_username}`} target="_blank">
                                            <img src="/images/insta.png" style={{ height: "30px", paddingRight: "10px" }} alt="Instagram" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>







                    <div class="container pt-5 pb-4">
                        <div class="row">

                            <div class="col d-flex justify-content-center">
                                <div class="card card-2 ccard" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h1 style={{ fontWeight: "bold", fontSize: "2rem" }}>{personalData.experience}</h1>
                                    <p style={{ fontWeight: "500" }}>Years of Exp.</p>
                                </div>
                            </div>
                            <div class="col d-flex justify-content-center">
                                <div class="card card-2 ccard" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h1 style={{ fontWeight: "bold", fontSize: "2rem" }}>{certificateCount}</h1>
                                    <div class="" style={{ textAlign: "center", color: "#777", }}>Certifications</div>
                                </div>
                            </div>

                            <div class="col d-flex justify-content-center">
                                <div class="card card-2 ccard" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h1 style={{ fontWeight: "bold", fontSize: "2rem" }}>{rating === "NaN" ? "0" : rating}</h1>
                                    <div class="" style={{ color: "white", display: "flex", justifyContent: "center" }}>
                                        <ReactStars {...ratingExample} />
                                    </div>
                                    <p style={{ fontWeight: "500" }}>Ratings</p>
                                </div>
                            </div>

                        </div>
                    </div>



                    <section className="section bg-default text-center p-5" id="portfolio" style={{ padding: "22px", backgroundColor: "white" }}>
                        <div className="container">
                            <h2 style={{ color: "black" }}>PORTFOLIO</h2>
                            <p className="block-lg p-3" style={{ textAlign: "justify", textJustify: "inter-word", color: "black" }}>
                                Welcome to my portfolio! Here you can explore a glimpse of my work and expertise. I take pride in delivering the best in every project I work on, whether it’s for a special occasion, a client request, or simply to showcase my skills.
                            </p>
                        </div>

                        <div className="">
                            <div className="row">
                                {/* <div className="col-lg-12 enda">
                                    {personalData.gallery?.length > 0 ? (
                                        personalData.gallery.length < 5 ? (
                                            <div className="container pt-5 pb-5">
                                                <div className="row">
                                                    {personalData.gallery?.map((item, index) => (
                                                        <div className="col d-flex justify-content-center" key={index}>
                                                            <div className="slide">
                                                                <img
                                                                    style={{ height: "12rem", objectFit: "fill", width: "11rem" }}
                                                                    src={item?.video_url || item?.image_url}
                                                                    alt={personalData?.username || "Gallery Image"}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <div id="slider-container1" className="slider">
                                                {personalData.gallery?.map((item, index) => (
                                                    <div className="slide" key={index}>
                                                        <img src={item?.video_url || item?.image_url} alt={personalData?.username || "Gallery Image"} />
                                                    </div>
                                                ))}

                                                <div onClick={() => window.prevSs()} className="control-prev-btn">
                                                    {`<`}
                                                </div>
                                                <div onClick={() => window.nextSs()} className="control-next-btn">
                                                    {`>`}
                                                </div>
                                            </div>
                                        )
                                    ) : (
                                        <div className="row" style={{ textAlign: "center" }}>
                                            <h1 style={{ color: "grey" }}>No Photos Found!</h1>
                                        </div>
                                    )}
                                    <div className="overlay"></div>
                                </div> */}
                                {/* <div className="col-lg-12 enda">
                                    {personalData.gallery?.length > 0 ? (
                                        personalData.gallery.length < 5 ? (
                                            <div className="container pt-5 pb-5">
                                                <div className="row">
                                                    {personalData.gallery?.map((item, index) => (
                                                        <div className="col d-flex justify-content-center" key={index}>
                                                            <div className="slide">
                                                                <MediaThumb
                                                                    item={item}
                                                                    boxStyle={{ height: "12rem", width: "11rem", objectFit: "cover", borderRadius: 8 }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <div id="slider-container1" className="slider">
                                                {personalData.gallery?.map((item, index) => (
                                                    <div className="slide" key={index}>
                                                        <MediaThumb
                                                            item={item}
                                                            boxStyle={{ height: "12rem", width: "100%", objectFit: "cover" }}
                                                        />
                                                    </div>
                                                ))}
                                                <div onClick={() => window.prevSs()} className="control-prev-btn">{`<`}</div>
                                                <div onClick={() => window.nextSs()} className="control-next-btn">{`>`}</div>
                                            </div>
                                        )
                                    ) : (
                                        <div className="row" style={{ textAlign: "center" }}>
                                            <h1 style={{ color: "grey" }}>No Photos Found!</h1>
                                        </div>
                                    )}
                                    <div className="overlay"></div>
                                </div> */}

                                <div className="col-lg-12 enda">
                                    {personalData.gallery?.length > 0 ? (
                                        personalData.gallery.length < 5 ? (
                                            <div className="container pt-5 pb-5">
                                                <div className="row">
                                                    {personalData.gallery.map((item, index) => (
                                                        <div className="col d-flex justify-content-center" key={index}>
                                                            <div className="slide">
                                                                <MediaThumb
                                                                    item={item}
                                                                    boxStyle={{
                                                                        height: "12rem",
                                                                        width: "11rem",
                                                                        objectFit: "cover",
                                                                        borderRadius: 8,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="gallery-slider-wrapper">
                                                <button className="scroll-btn left" onClick={() => scrollGallery("left")}>⮜</button>
                                                <div className="gallery-slider" ref={galleryRef}>
                                                    {personalData.gallery.map((item, index) => (
                                                        <div className="slide" key={index}>
                                                            <MediaThumb
                                                                item={item}
                                                                boxStyle={{
                                                                    height: "12rem",
                                                                    width: "11rem",
                                                                    objectFit: "cover",
                                                                    borderRadius: 8,
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                                <button className="scroll-btn right" onClick={() => scrollGallery("right")}>➤</button>
                                            </div>
                                        )
                                    ) : (
                                        <div className="row" style={{ textAlign: "center" }}>
                                            <h1 style={{ color: "grey" }}>No Photos Found!</h1>
                                        </div>
                                    )}
                                </div>



                                {/* <div className="col-lg-12 enba">
                                    <div id="slider-container" className="slider">
                                        {personalData.gallery?.map((item, index) => (
                                            <div className="slide" key={index}>
                                                <img src={item?.video_url || item?.image_url} alt={personalData?.username || "Gallery Image"} />
                                            </div>
                                        ))}

                                        <div onClick={() => window.prevS()} className="control-prev-btn">
                                            {`<`}
                                        </div>
                                        <div onClick={() => window.nextS()} className="control-next-btn">
                                            {`>`}
                                        </div>
                                    </div>

                                    <div className="overlay"></div>
                                </div> */}
                                <div className="col-lg-12 enba">
                                    <div id="slider-container" className="slider">
                                        {personalData.gallery?.map((item, index) => (
                                            <div className="slide" key={index}>
                                                <MediaThumb
                                                    item={item}
                                                    boxStyle={{ height: "18rem", width: "100%", objectFit: "cover" }}
                                                />
                                            </div>
                                        ))}
                                        <div onClick={() => window.prevS()} className="control-prev-btn">{`<`}</div>
                                        <div onClick={() => window.nextS()} className="control-next-btn">{`>`}</div>
                                    </div>
                                    <div className="overlay"></div>
                                </div>
                            </div>

                            <div className="col-12" style={{ textAlign: "center" }}>
                                <Link
                                    to={`/${params.id.toLowerCase()}/gallery`}
                                    className="button"
                                    style={{
                                        marginBottom: "0rem",
                                        marginTop: "2rem",
                                        color: "black",
                                        backgroundImage: "linear-gradient(#fe8e4e, #fedc56)",
                                        borderColor: "white",
                                    }}
                                >
                                    View more
                                </Link>
                            </div>
                        </div>
                    </section>





                    <section class="section bg-default text-center pt-5" id="services">
                        <div class="container">
                            <h2>SERVICES</h2>
                        </div>
                    </section>
                    <section class="" >



                        <div class="" >
                            <div class="row" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>

                                {personalService.services.length == 0 ? <div class="row" style={{ textAlign: "center" }}>
                                    <h1 style={{ color: "grey", fontSize: "28px", padding: "48px" }}>No Services Found!</h1>
                                </div> : ""}

                                {personalService.services.slice(0, 3).map((e, index) => (
                                    <div key={index} class="col-md-4 mb-3" style={{ padding: "3rem" }}>
                                        <div class="" style={{
                                            borderStyle: "solid", borderWidth: "3px",
                                            borderImage: "linear-gradient(45deg, rgb(252,79,135), rgb(255,242,86)) 1"
                                        }}>
                                            <img class="img-fluid" alt="100%x280" src={e.image} />
                                            <div class="p-3" style={{ color: "white", backgroundColor: "#e92b91", textAlign: "center", fontSize: "17px", fontWeight: "600" }}><span>{e.display_name}</span></div>
                                            <div class="p-2" style={{ textAlign: "start" }}>
                                                <div style={{ height: "5.5rem" }}><p class="card-title" style={{
                                                    fontSize: "11px", color: "black", textAlign: "justify", fontWeight: "400", overflow: "hidden",
                                                    textOverflow: "ellipsis", display: "-webkit-box", webkitLineClamp: "3", lineClamp: "2", webkitBoxOrient: "vertical"
                                                }}>{e.details}</p></div>
                                            </div>
                                            <div class="container mb-4">
                                                <div class="row">
                                                    <div class="col-sm-4" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "12px", fontWeight: "600", color: "black" }}>INR {e.amount}/-</span>
                                                    </div>
                                                    <div class="col-sm-4" style={{ textAlign: "center" }} onClick={() => enquiryStatus(e.display_name)} >
                                                        {/* <span style={{ fontSize: "12px", fontWeight: "600", color: "black", cursor: "pointer" }}>Raise Enquiry</span> */}
                                                    </div>
                                                    {/* <div class="col-sm-4" style={{ textAlign: "center" }} onClick={() => appointmentStatus(e.display_name, e.type, e.amount)} >
                                                        <span style={{ font: "bold 12px/1.5 Roboto, sans-serif", color: "#fe8e4e", cursor: "pointer" }}>Book Now</span>
                                                    </div> */}
                                                    <div class="col-sm-4">
                                                        <a href={`https://api.whatsapp.com/send?phone=${personalData.phone_no}`} target="_blank">
                                                            <img src="/images/whatsappp.png" style={{ height: "30px", paddingRight: "10px" }} alt="WhatsApp" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}



                            </div>
                        </div>
                        <div class="col-12 pb-4" style={{ textAlign: "center", }}><Link to={`/${params.id.toLowerCase()}/services`} class="button" href="#" style={{ marginBottom: "0rem", marginTop: "1rem", color: "black", backgroundImage: "linear-gradient(#fe8e4e, #fedc56)", borderColor: "transparent", fontSize: "12px" }}>View more</Link></div>


                    </section >




                    <section class="section bg-default text-center p-5" id="reviews" style={{
                        padding: "22px",
                        backgroundColor: "white"
                    }}>

                        <div class="row row-50">
                            <div class="col-lg-6" style={{ textAlign: "initial" }}>
                                <div class="block-xs">
                                    <h2 class="heading-decorate" style={{ fontFamily: "Roboto, sans-serif", color: "black" }}>Testimonials<br class="d-inline" /><span class="divider"></span>of Our Clients</h2>
                                    <p class="big  text-gray-800" style={{ fontFamily: "Roboto, sans-serif", textAlign: "justify", fontSize: "15px", color: "black", }}>If you’ve already availed my services, please take out a moment to give me your feedback! Your testimonial can help others decide if my services are right for them, and it also helps me improve my work. I value your opinion and would love to hear your thoughts.</p>
                                    {/* <div class="row" style={{ display: "flex" }}>
                                    <div class="col-md-6"><Link to={`/${params.id.toLowerCase()}/review`}><p style={{ color: "#fe8e4e", fontWeight: "600" }}>Give a review</p></Link></div>
                                    <div class="col-md-6" style={{ textAlign: "end" }}><Link to={`/${params.id.toLowerCase()}/customer_review`}><span class="viewAll" style={{ padding: "6px", paddingLeft: "20px", paddingRight: "21px" }}>View All</span></Link></div>
                                </div> */}
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-6 col-lg-6" style={{ textAlign: "center" }}><Link to={`/${params.id.toLowerCase()}/review`}><p style={{ color: "#fe8e4e", fontWeight: "600" }}>Give a review</p></Link></div>
                                        <div class="col-xs-6 col-sm-6 col-lg-6" style={{ textAlign: "center" }}><Link to={`/${params.id.toLowerCase()}/customer_review`}><span class="viewAll" style={{ padding: "6px", paddingLeft: "20px", paddingRight: "21px", }}>View All</span></Link></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">


                                <section class="" aria-label="Gallery">

                                    <TestimonialSlider />

                                </section>
                            </div>
                        </div>
                    </section>


                    {/* <div class="container">
                        <h2>REACH OUT TO US</h2>
                    </div>
                    <div class="container">
                        <div class="row pl-5 pr-5">
                            <div class="col-md-4">
                                <h4></h4>
                                <ul class="address1" style={{ padding: "0px" }}>
                                    <li style={{ textAlign: "left" }}><i class="fa fa-phone" style={{ fontSize: "25px" }}></i>{maskPhoneNumber(personalData.phone_no)}</li>
                                    <li style={{ textAlign: "left" }}><i class="fa fa-suitcase" style={{ fontSize: "25px" }}></i>Willing to travel - {personalData.willing_to_travel}</li>
                                    <li style={{ textAlign: "left" }}><i class="fa fa-map-marker" style={{ fontSize: "25px" }}></i>{personalData.detailed_address}</li>
                                    <li style={{ textAlign: "left" }}><i class="fa fa-paint-brush" style={{ fontSize: "25px" }}></i>Parlour Type - {personalData.parlour_type}</li>
                          
                                </ul>
                            </div>
                            <div class="col-md-4">
                                <div class="outer">
                                    <div class="inner"></div>
                                </div>
                            </div>

                            <div class="col-md-4" >
                                <span style={{
                                    display: "flex",
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    paddingBottom: "10px"
                                }}>Operational Days & Hours</span>
                                <ul>
                                    {personalData.working_days?.length > 0 ? (
                                        personalData.working_days.map((e, index) => (
                                            <li key={index} style={{ textAlign: "start" }}>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        width: "14%",
                                                    }}
                                                >
                                                    {e}
                                                </div>
                                                - <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                                    {personalData.working_hours || "N/A"}
                                                </span>
                                            </li>
                                        ))
                                    ) : (
                                        <li>No working days available</li> 
                                    )}
                                </ul>

                            </div>

                        </div>

                    </div> */}



                    {/* <Footer /> */}
                    <div class="footer-04">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <ul style={{ paddingLeft: "3rem", paddingTop: "2rem", }}>
                                        <Link to="/" onClick={() => window.scrollTo(0, 0)}><li style={{ color: "white" }}>Home</li></Link>
                                        <Link to="/aboutus"><li style={{ color: "white" }}>About Us</li></Link>
                                        <Link to="/privacy_policy"><li style={{ color: "white" }}>Privacy Policy</li></Link>
                                        <Link to="/contactus"><li style={{ color: "white" }}>Contact Us</li></Link>
                                        {/* <li style={{ color: "white" }}>About Us</li> */}
                                        {/* <li style={{ color: "white" }}>Privacy Policy</li> */}
                                        {/* <li style={{ color: "white" }}>Contact Us</li> */}
                                        <li><img style={{ width: "9rem", paddingTop: "1rem" }} alt="playstore" src="https://b.zmtcdn.com/data/webuikit/23e930757c3df49840c482a8638bf5c31556001144.png" loading="lazy" class="sc-s1isp7-5 fyZwWD" /></li>
                                    </ul>
                                </div>
                                <div class="col-md-6 pt-3">
                                    <div class="" style={{ alignItems: "stretch", display: "flex", width: "100%" }}>
                                        <div class="">
                                            {/* <Select
                                                defaultValue={selectedOption}
                                                onChange={setSelectedOption}
                                                options={options}
                                                placeholder="Search via state"
                                            /> */}

                                        </div>
                                        <ul class="ftco-footer-social p-0 pt-4 mr-4" style={{ display: "flex", justifyContent: "center" }}>
                                            <a href="https://www.facebook.com/youvatiofficial?mibextid=ZbWKwL" target="_blank"><img src="/images/facebookk.png" style={{ height: "30px", paddingRight: "10px" }}></img></a>
                                            <a href="https://api.whatsapp.com/send?phone=7428790444" target="_blank"><img src="/images/whatsappp.png" style={{ height: "30px", paddingRight: "10px" }}></img></a>
                                            <a href="https://instagram.com/youvatiofficial?igshid=MzRlODBiNWFlZA==" target="_blank"><img src="/images/insta.png" style={{ height: "30px", paddingRight: "10px" }}></img></a>
                                            <a href="https://twitter.com/Youvatiofficial?s=20" target="_blank"><img src="/images/twitter.png" style={{ height: "30px", paddingRight: "10px" }}></img></a>
                                            <a href="https://www.linkedin.com/company/youvati/ " target="_blank"><img src="/images/linkedin.png" style={{ height: "30px", paddingRight: "10px" }}></img></a>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="" style={{ textAlign: "center", background: "#272727", color: "white", paddingBottom: "1rem" }}>Powered By ~ Youvati</div>
                    </div>
                </div>

            }


            <div class="col-md-12">
                <div class="myId modal fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal-form" aria-hidden="true" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-body">

                                {showEnquiry ? <>
                                    <div class="">
                                        <form class="" id="" onSubmit={handleSubmitE}>
                                            <div class="">
                                                <div class="" style={{ textAlign: "center", }}><span style={{ color: "black", fontSize: "25px", fontWeight: "700", textTransform: "uppercase" }}>Raise Enquiry</span></div>
                                                <div class="" style={{ textAlign: "center", color: "black", paddingTop: "10px" }}>
                                                </div>
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <input style={{
                                                                // width: "17rem",
                                                                height: "45px",
                                                                padding: "12px 20px",
                                                                boxSizing: "border-box",
                                                                border: "2px solid #ccc",
                                                                borderRadius: "4px",
                                                                backgroundColor: "#f8f8f8",
                                                                fontSize: "16px",
                                                                resize: "none"
                                                            }} class="w3l_text_box" id="name" onChange={handleChangeE} value={submitEnquiry.name} placeholder="Full Name" name="Full Name" type="text" required />
                                                        </div>

                                                        <div class="col-md-6">
                                                            <input style={{
                                                                // width: "17rem",
                                                                height: "45px",
                                                                padding: "12px 20px",
                                                                boxSizing: "border-box",
                                                                border: "2px solid #ccc",
                                                                borderRadius: "4px",
                                                                backgroundColor: "#f8f8f8",
                                                                fontSize: "16px",
                                                                resize: "none"
                                                            }} class="w3l_text_box" id="phone_no" onChange={handleChangeE} value={submitEnquiry.phone_no} placeholder="Phone Number" name="Phone Number" type="number" required />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <input style={{
                                                                // width: "17rem",
                                                                height: "45px",
                                                                padding: "12px 20px",
                                                                boxSizing: "border-box",
                                                                border: "2px solid #ccc",
                                                                borderRadius: "4px",
                                                                backgroundColor: "#f8f8f8",
                                                                fontSize: "16px",
                                                                resize: "none"
                                                            }} class="w3l_text_box" value={serviceName} placeholder="Service Name" name="Service Name" type="text" required />
                                                        </div>


                                                    </div>
                                                </div>
                                                <textarea style={{
                                                    width: "100%",
                                                    height: "15px",
                                                    padding: "12px 20px",
                                                    boxSizing: "border-box",
                                                    border: "2px solid #ccc",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f8f8f8",
                                                    fontSize: "16px",
                                                    resize: "none"
                                                }} class="w3l_text_box" id="message" onChange={handleChangeE} value={submitEnquiry.message} placeholder="Write a enquiry..." name="Enquiry" required />



                                                <div class="modal-footer">
                                                    <a class="btn bg-gradient-info btn-sm mb-0" style={{ color: "white" }} onClick={() => closeModel()}>Close</a>
                                                    {/* <a class="btn bg-gradient-success btn-sm mb-0" style={{ color: "white" }}>Submit</a> */}
                                                    <button type='submit' class="btn bg-gradient-danger btn-sm mb-0" style={{ backgroundColor: "green", color: "white" }}>Submit</button>
                                                </div>


                                            </div>
                                        </form>
                                    </div>
                                </> : <></>}
                                {showAp ? <>
                                    <div class="">
                                        <form class="" id="" onSubmit={handleSubmitAp}>
                                            <div class="">
                                                <div class="" style={{ textAlign: "center", }}><span style={{ color: "black", fontSize: "25px", fontWeight: "700", textTransform: "uppercase" }}>Appointment Booking</span></div>
                                                <div class="" style={{ textAlign: "center", color: "black", paddingTop: "10px" }}>
                                                </div>
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <input style={{
                                                                // width: "17rem",
                                                                height: "45px",
                                                                padding: "12px 20px",
                                                                boxSizing: "border-box",
                                                                border: "2px solid #ccc",
                                                                borderRadius: "4px",
                                                                backgroundColor: "#f8f8f8",
                                                                fontSize: "16px",
                                                                resize: "none"
                                                            }} class="w3l_text_box" id="name" onChange={handleChangeAp} value={submitAppointment.name} placeholder="Full Name" name="Full Name" type="text" required />
                                                        </div>

                                                        <div class="col-md-6">
                                                            <input style={{
                                                                // width: "17rem",
                                                                height: "45px",
                                                                padding: "12px 20px",
                                                                boxSizing: "border-box",
                                                                border: "2px solid #ccc",
                                                                borderRadius: "4px",
                                                                backgroundColor: "#f8f8f8",
                                                                fontSize: "16px",
                                                                resize: "none"
                                                            }} class="w3l_text_box" id="phone" onChange={handleChangeAp} value={submitAppointment.phone} placeholder="Phone Number" name="Phone Number" type="number" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <li>
                                                                <label style={{ display: "flex" }}>Service Name</label>
                                                                <input style={{
                                                                    // width: "17rem",
                                                                    height: "45px",
                                                                    padding: "12px 20px",
                                                                    boxSizing: "border-box",
                                                                    border: "2px solid #ccc",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: "#f8f8f8",
                                                                    fontSize: "16px",
                                                                    resize: "none"
                                                                }} class="w3l_text_box" value={serviceName} placeholder="Service Name" name="Service Name" type="text" required />
                                                            </li>

                                                        </div>

                                                        <div class="col-md-6">
                                                            <li>
                                                                <label style={{ display: "flex" }}>Start Datetime</label>
                                                                <input type="datetime-local" id="start_date_time" min={currentDate} onChange={handleChangeAp} value={submitAppointment.start_date_time} class="form-control" required />
                                                            </li>
                                                        </div>


                                                    </div>
                                                </div>

                                                <textarea style={{
                                                    width: "100%",
                                                    height: "15px",
                                                    padding: "12px 20px",
                                                    boxSizing: "border-box",
                                                    border: "2px solid #ccc",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f8f8f8",
                                                    fontSize: "16px",
                                                    resize: "none"
                                                }} class="w3l_text_box" id="description" onChange={handleChangeAp} value={submitAppointment.description} placeholder="Write a description..." name="Description" />

                                                <div class="">
                                                    <div class="col-md-6">
                                                        <div class="form-check">
                                                            <input
                                                                type="radio"
                                                                class="form-check-input"
                                                                id="in_parlour"
                                                                name="topping"
                                                                value="no"
                                                                checked={topping === "no"}
                                                                style={{ display: "block", position: 'absolute' }}
                                                                onChange={onOptionChange}
                                                            />

                                                            <label class="form-check-label" for="checkbox1">
                                                                In Parlour
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {personalData.willing_to_travel === "No" ? <>
                                                    </> : <>
                                                        <div class="col-md-6">
                                                            <div class="form-check">
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    id="outstation"
                                                                    name="topping"
                                                                    value="yes"
                                                                    onChange={onOptionChange}
                                                                    style={{ display: "block", position: 'absolute' }}
                                                                />

                                                                <label class="form-check-label" for="checkbox2">
                                                                    At Home/Outstation
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </>}
                                                </div>

                                                {topping === "yes" ? <>    <textarea style={{
                                                    width: "100%",
                                                    height: "5px",
                                                    padding: "12px 20px",
                                                    boxSizing: "border-box",
                                                    border: "2px solid #ccc",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f8f8f8",
                                                    fontSize: "16px",
                                                    resize: "none",
                                                    minHeight: "59px",
                                                }} class="w3l_text_box" id="address" onChange={handleChangeAp} value={submitAppointment.address} placeholder="Address......." name="address" required />
                                                </>
                                                    :
                                                    <></>
                                                }


                                                <div class="modal-footer">
                                                    <a class="btn bg-gradient-info btn-sm mb-0" style={{ color: "white" }} onClick={() => closeModel()}>Close</a>
                                                    {/* <a class="btn bg-gradient-success btn-sm mb-0" style={{ color: "white" }}>Submit</a> */}
                                                    <button type='submit' class="btn bg-gradient-danger btn-sm mb-0" style={{ backgroundColor: "green", color: "white" }}>Submit</button>
                                                </div>


                                            </div>
                                        </form>
                                    </div>
                                </> : <></>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewPortfolio;
